export default "/images/users.svg?ecf7978c156cfd653ca819764bb89015";